export default __webpack_public_path__ + "static/media/Twitter.e16cf8c5.png";